import { render, staticRenderFns } from "./lainaa.vue?vue&type=template&id=f8eb5e20&"
import script from "./lainaa.vue?vue&type=script&lang=js&"
export * from "./lainaa.vue?vue&type=script&lang=js&"
import style0 from "./lainaa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports